import { useCallback, useState } from "react";

export const WIND_KEY = "divespots.map.wind";

/** Off unless this device turned it on; storage may be missing or throw (private mode). */
export function readWindPref(): boolean {
  try {
    return localStorage.getItem(WIND_KEY) === "on";
  } catch {
    return false;
  }
}

export function writeWindPref(on: boolean): void {
  try {
    if (on) localStorage.setItem(WIND_KEY, "on");
    else localStorage.removeItem(WIND_KEY);
  } catch {
    /* the choice just is not remembered */
  }
}

/** The overlay switch, remembered per device. */
export function useWindPref(): [boolean, (on: boolean) => void] {
  const [on, setOn] = useState(readWindPref);
  const set = useCallback((v: boolean) => {
    setOn(v);
    writeWindPref(v);
  }, []);
  return [on, set];
}

export const WEATHER_INFO_KEY = "divespots.map.weatherInfo";

/** The time bar's details panel: closed unless this browser opened it; storage may throw. */
export function readInfoOpen(): boolean {
  try {
    return localStorage.getItem(WEATHER_INFO_KEY) === "open";
  } catch {
    return false;
  }
}

export function writeInfoOpen(open: boolean): void {
  try {
    if (open) localStorage.setItem(WEATHER_INFO_KEY, "open");
    else localStorage.removeItem(WEATHER_INFO_KEY);
  } catch {
    /* the panel just starts closed next time */
  }
}
